
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Packages from './components/Packages';
import Gallery from './components/Gallery';
import Quiz from './components/Quiz';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import { SchemaOrg, organizationSchema, serviceSchema } from '../../utils/seo';

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const webPageSchema = {
    '@type': 'WebPage',
    name: 'theintimateedit - Surprise Decoration Specialists',
    description: 'Create unforgettable intimate moments with customizable surprise decoration packages for romantic proposals, birthdays, anniversaries, and celebrations.',
    url: import.meta.env.VITE_SITE_URL || 'https://theintimateedit.com',
    mainEntity: {
      '@type': 'Organization',
      ...organizationSchema
    }
  };

  return (
    <>
      <SchemaOrg type="WebPage" data={webPageSchema} />
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="Service" data={serviceSchema} />
      
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Packages />
          <Gallery />
          <Quiz />
          <ContactForm />
        </main>
        <Footer />
      </div>
    </>
  );
}
